/* global newrelic */

import React from 'react';
import PropTypes from 'prop-types';

class PdpSharedRestrictedMaterialsLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = { Component: null };
    }
    componentDidMount() {
        import(/* webpackChunkName: "PdpSharedRestrictedMaterialsRenderer" */
        './PdpSharedRestrictedMaterialsRenderer')
            .then(({ PdpSharedRestrictedMaterialsRenderer: Component }) =>
                this.setState({ Component })
            )
            .catch(error => {
                if (typeof newrelic !== 'undefined') {
                    newrelic.noticeError(error);
                }
                return null;
            });
    }
    render() {
        const { Component } = this.state;
        return Component && <Component {...this.props} />;
    }
}

PdpSharedRestrictedMaterialsLoader.propTypes = {
    environment: PropTypes.object.isRequired,
    itemId: PropTypes.string,
    isClient: PropTypes.bool,
    theme: PropTypes.object,
};

export { PdpSharedRestrictedMaterialsLoader };
